/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';
import { CommuneStatusManager } from '../services/manager';
import { getCommuneByRegion } from '../services/commune';
import { listCommuneActions } from './definition';

function communeError(e: string, commune: any) {
    return {
        type: listCommuneActions.LIST_COMMUNE_ERROR,
        error: e,
        data: commune,
    };
}

// Reducers of Single Commune
function communeIsLoading() {
    return {
        type: listCommuneActions.LIST_COMMUNE_IS_LOADING,
    };
}

const communeListReset = () => {
    return {
        type: listCommuneActions.LIST_COMMUNE_RESET,
    };
};


function communeSetList(communes: any) {
    return {
        type: listCommuneActions.LIST_COMMUNE,
        data: communes,
    };
}

/**
 * Reducer to rest a communes
 * @param values Data to reset communes
 */
export const resetStateCommune = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(communeListReset());
    };
};

/**
 * Reducer to rest a communes
 * @param values Data to reset communes
 */
export const resetCommuneReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(communeListReset());
    };
};

/**
 * Reducer to reset Communes
 * @param values Values to reset communes
 */
export const resetCommune = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(communeListReset());
    };
};

// List

/**
 * Reducer to get a commune by id
 * @param id Id of commune to find
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getCommuneByRegions = (query) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(communeIsLoading());
        try {
            const response = await getCommuneByRegion(query);
            if (response?.statusCode === CommuneStatusManager.COUNTIES_LISTED && response.data) {
                dispatch(communeSetList(response));
            } else {
                dispatch(communeError('Could not get commune regionId: ', query.id));
            }
        } catch (error: any) {
            const Err = {
                data: query.id,
                message: error,
                code: 'NOT_FOUNT',
            }
            dispatch(communeError('No se pudo obtener el commune', Err ));
        }
    };
};
